// extracted by mini-css-extract-plugin
module.exports = {"rotation":"RivenditoriTemplate_rotation__F8jSp"};